import { render, staticRenderFns } from "./HazardDetail.vue?vue&type=template&id=4ae9a473&scoped=true&"
import script from "./HazardDetail.vue?vue&type=script&lang=js&"
export * from "./HazardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae9a473",
  null
  
)

export default component.exports